



// single-product start


$('.single-product__big-items').slick({
    draggable: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.single-product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});
$('.single-product__small-items').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.single-product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
     responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
    ]
});


// single-product end

// testimonials start



$('.testimonials__items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


$('.testimonials__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.testimonials__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// testimonials end




document.addEventListener('DOMContentLoaded', function () {
    const headerRight = document.querySelector('.header__right');
    const hero = document.querySelector('.hero');
    if (window.innerWidth >= 100) {
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    headerRight.classList.add('sticky-right', 'slide-in');
                } else {
                    headerRight.classList.remove('slide-in');
                    setTimeout(() => {
                        headerRight.classList.remove('sticky-right');
                    }, 300); // allow animation to complete before removing position
                }
            });
        }, {
            root: null,
            threshold: 0
        });
        if (hero) {
            observer.observe(hero);
        }
    }
});



$("[href^='#']").click(function() {
    id=$(this).attr("href")
    $('html, body').animate({
        scrollTop: $(id).offset().top
    }, 1000);
  });
  







// cart-drawer start

$(".header__cart , .menu__header-cart").on('click', function () {
    $("body").addClass('cart-open');
    setTimeout(function () {
        $(".cart-drawer__left").addClass('fade-in');
    }, 600);
});
$(".cart-drawer__close , .cart-drawer__left , .overlay").on('click', function () {
    $("body").removeClass('cart-open');
    $(".cart-drawer__left").removeClass('fade-in');
});


// cart-drawer end





// soda-slider start

$('.soda-slider__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


// soda-slider end




// faq start


$(".faq__item-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq__item-content").slideUp();
    } else {
        $(".faq__item-content").slideUp();
        $(".faq__item-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq__item-content").slideDown();
    }
})


// faq end



// menu start



$(".header__mobi-menu").on('click', function () {
    $("body").addClass('menu-open');
})
$(".menu__close , .menu__header-cart").on('click', function () {
    $("body").removeClass('menu-open');
});
$(".menu__list-items li a").on('click', function () {
    $("body").removeClass('menu-open');
})
// menu end



// fuatured-product start



if ($(Window).width() < 767) {
    $('.fuatured-product__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });

  $('.fuatured-product__bot-wrap').slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        buttons: false,
    });

    $('.announcement__text').slick({
        speed: 8000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        buttons: false,
        variableWidth: true,
    });
}





// fuatured-product end


// product start


if ($(Window).width() < 768) {
    $('.product-cards').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });
}


// product end



// science start


$(".science__dropdown-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".science__dropdown-content").slideUp();
    } else {
        $(".science__dropdown-content").slideUp();
        $(".science__dropdown-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".science__dropdown-content").slideDown();
    }
})


// science end